<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>local_bar</mat-icon>
        <div>Eventos</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">

        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>

      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card id='table-body'>

    <!-- TABLE -->
    <mat-table [dataSource]="_eventService.eventDataSource">

      <!-- Icon Column -->
      <ng-container matColumnDef="icon" class='mural-name'>
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>local_bar</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.startDay | date: 'dd/MM/yyyy' }} </mat-cell>
      </ng-container>

            <!-- more Column -->
      <ng-container matColumnDef="more">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <a mat-button [matMenuTriggerFor]="menu_options" style='background-color: whitesmoke;'>
            <mat-icon class='icon-email'>
              more_vert
            </mat-icon>
          </a>
          <mat-menu #menu_options="matMenu" yPosition='above' xPosition='before'>

            <!-- Menu Cartas com submenu -->
            <button mat-menu-item [matMenuTriggerFor]="lettersMenu">
              <mat-icon>mail</mat-icon>
              <span class="nav-caption">Cartas</span>
            </button>
            <mat-menu #lettersMenu="matMenu">
              <a mat-menu-item (click)='gotoLettersSpeakers(element)'>
                <span class="nav-caption">Palestrantes</span>
              </a>
              <a mat-menu-item (click)='gotoLettersSubscriptions(element)'>
                <span class="nav-caption">Inscritos</span>
              </a>
            </mat-menu>

            <!-- Menu Certificados com submenu -->
            <button mat-menu-item [matMenuTriggerFor]="certificatesMenu">
              <mat-icon>bookmark</mat-icon>
              <span class="nav-caption">Certificados</span>
            </button>
            <mat-menu #certificatesMenu="matMenu">
              <a mat-menu-item (click)='gotoCertificatesSpeakers(element)'>
                <span class="nav-caption">Palestrantes</span>
              </a>
              <a mat-menu-item (click)='gotoCertificatesSubscriptions(element)'>
                <span class="nav-caption">Inscritos</span>
              </a>
              <a mat-menu-item (click)='gotoCertificatesArchives()'>
                <span class="nav-caption">Arquivo</span>
              </a>
            </mat-menu>


            <!-- Menu Programação com submenu -->
            <button mat-menu-item [matMenuTriggerFor]="programMenu">
              <mat-icon>preview</mat-icon>
              <span class="nav-caption">Programação</span>
            </button>
            <mat-menu #programMenu="matMenu">
              <a mat-menu-item (click)='gotoPublish(element)'>
                <span class="nav-caption">Publicar</span>
              </a>
              <a mat-menu-item (click)='gotoSchedule(element)'>
                <span class="nav-caption">Visualizar</span>
              </a>
            </mat-menu>

          </mat-menu>

        </mat-cell>
      </ng-container>
      

      <!-- preview Column -->
      <ng-container matColumnDef="preview">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='preview(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-close'>
              menu
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class="icon-info">
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
            <mat-icon class="icon-delete">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

    <mat-paginator [pageSizeOptions]="[6, 12, 24, 48]"></mat-paginator>

  </mat-card>

</div>